import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_BEGIN,
  USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_SUCCESS,
  USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_FAILURE,
  USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function confirmarCadastroPorToken(token, callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_BEGIN,
    data: token,
    callback,
  };
}

export function dismissConfirmarCadastroPorTokenError() {
  return {
    type: USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_BEGIN actions
export function* doConfirmarCadastroPorToken(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  const UsuarioApi = new Services['UsuarioApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield UsuarioApi.confirmarEmail({ token: action.data });
  } catch (err) {
    yield put({
      type: USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_FAILURE,
      data: { error: err },
    });

    if (action.callback) {
      action.callback(USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_SUCCESS,
    data: res,
  });

  if (action.callback) {
    action.callback(USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchConfirmarCadastroPorToken() {
  yield takeLatest(USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_BEGIN, doConfirmarCadastroPorToken);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_BEGIN:
      return {
        ...state,
        registro: {},
        confirmarCadastroPorTokenPending: true,
        confirmarCadastroPorTokenError: null,
      };

    case USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_SUCCESS:
      return {
        ...state,
        registro: action.data,
        confirmarCadastroPorTokenPending: false,
        confirmarCadastroPorTokenError: null,
      };

    case USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_FAILURE:
      return {
        ...state,
        confirmarCadastroPorTokenPending: false,
        confirmarCadastroPorTokenError: action.data.error,
      };

    case USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_DISMISS_ERROR:
      return {
        ...state,
        confirmarCadastroPorTokenError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/usuarios/redux/confirmarCadastroPorToken.js